import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, Button, Label } from 'reactstrap';
import { sharedLabelsPath } from '../../../reducers/common/localization';
import _ from "lodash";
import './UserSubRoleMissingModal.css';

class UserSubRoleMissingModal extends Component {
    render() {
        return (
            <Modal isOpen={this.props.isOpen}>
                <ModalBody>
                    <Label>
                        <h6>{_.get(this.props.translation, "sub_role_missing.no_access_label")}</h6>
                        <span>{
                            this.props.updateSubRolesOnly ?
                                null :
                                _.get(this.props.translation, "sub_role_missing.continue_label")
                        }
                        </span>
                    </Label>
                    <div className="user-sub-role-missing-modal-button-container">
                        <Button className="user-sub-role-missing-modal-button olive-green-btn" onClick={this.onSubmit}>{_.get(this.props.translation, sharedLabelsPath.okey_button)}</Button>
                    </div>
                </ModalBody>
            </Modal>
        );
    }

    onSubmit = () => {
        this.props.onCancel();
        if (!this.props.updateSubRolesOnly) {
            this.props.onSubmit();
        }
    }
}

UserSubRoleMissingModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    updateSubRolesOnly: PropTypes.bool,
    translation: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
};

export default UserSubRoleMissingModal;



// WEBPACK FOOTER //
// ./src/components/commonComponents/userSubRoleMissingModal/UserSubRoleMissingModal.js